import React from 'react'

import NewsItemDate from './Items/NewsItemDate'
import NewsItemTitle from './Items/NewsItemTitle'

const NewsListItem = ({ postIndex, postItem }) => {
	// Validation des props
	if (!postItem || !postItem._source || !postItem._source.permalink) {
		return (
			<article 
				className="news-list-item-error"
				aria-label="Élément d'actualité invalide"
				aria-describedby="news-item-error-description"
			>
				<div id="news-item-error-description" className="visually-hidden">
					Élément d'actualité non disponible ou corrompu
				</div>
			</article>
		)
	}

	const { _source } = postItem
	const { permalink, post_type, post_image, post_title } = _source
	
	// Normaliser l'URL pour gérer les accents
	const normalizedPermalink = permalink ? permalink.normalize('NFD').replace(/[\u0300-\u036f]/g, '') : permalink
	const postType = post_type || 'default'
	const rawTitle = (postItem.highlight && postItem.highlight.post_title) || post_title || 'Titre non disponible'
	const cleanTitle = rawTitle.replace(/(<([^>]+)>)/ig, '')
	const imageAlt = post_image ? cleanTitle : `${cleanTitle} - Aucune image disponible`
	const articleId = `news-item-${postIndex !== undefined ? postIndex : 'unknown'}`
	const articleLabel = `${cleanTitle} - ${postType}`

	return (
		<article 
			id={articleId}
			className={`news-list-item-content news-list-item-${postType}`}
			aria-label={articleLabel}
		>
			<a 
				className={`news-list-item-content news-list-item-${postType}`}
				target="_blank" 
				rel="noopener noreferrer" 
				href={normalizedPermalink}
				aria-describedby={`${articleId}-title ${articleId}-date`}
				aria-label={`Lire l'actualité : ${cleanTitle} (s'ouvre dans un nouvel onglet)`}
			>
				<div className="news-list-item-head">
					{post_image ? (
						<figure className="news-list-item-picture">
							<img
								src={post_image}
								alt={imageAlt}
								loading="lazy"
								decoding="async"
							/>
						</figure>
					) : (
						<div className="news-list-item-no-image" aria-hidden="true">
							<span className="visually-hidden">Aucune image pour cette actualité</span>
						</div>
					)}
				</div>
				<div className="news-list-item-infos" aria-labelledby={`${articleId}-title`}>
					<div id={`${articleId}-title`} className="news-list-item-title-wrapper">
						<NewsItemTitle postItem={postItem} />
					</div>
					<div id={`${articleId}-date`} className="news-list-item-date-wrapper">
						<NewsItemDate postItem={postItem} />
					</div>
				</div>
			</a>
		</article>
	)
}

export default NewsListItem
